module.exports = __webpack_public_path__ + "img/1566137207.79ebcd11.jpg";